import React, { useState } from 'react';
import { signInWithEmailAndPassword, sendPasswordResetEmail } from 'firebase/auth';
import { auth } from '../firebase/config';

// import {
//   auth,
//   signInWithEmailAndPassword,
//   sendPasswordResetEmail,
//   createUserWithEmailAndPassword,
//   setDoc,
//   doc,
//   db,
//   addDoc,
//   collection,
//   signOut,
//   onAuthStateChanged,
//   query,
//   where,
//   onSnapshot,
// } from '/Users/adityarouniyar/Desktop/convoai/src/firebase/config.js';

import Logo from '../components/common/Logo';

const LoginPage = ({ setModalType, closeModal }) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [message, setMessage] = useState('');

    const handleLogin = async (e) => {
        e.preventDefault();
        setError('');
        try {
            await signInWithEmailAndPassword(auth, email, password);
            closeModal();
        } catch (err) {
            console.error("Login error:", err);
            setError(err.message || "An error occurred during login. Please try again.");
        }
    };

    const handlePasswordReset = async () => {
        if (!email) {
            setError("Please enter your email address to reset password.");
            return;
        }
        setError('');
        setMessage('');
        try {
            await sendPasswordResetEmail(auth, email);
            setMessage("Password reset email sent! Check your inbox.");
        } catch (err) {
            console.error("Password reset error:", err);
            setError(err.message || "An error occurred while sending password reset email.");
        }
    };

    return (
        <div className="p-10 bg-white">
            <div>
                <div className="mx-auto h-12 w-auto flex justify-center">
                    <Logo />
                </div>
                <h2 className="mt-6 text-center text-3xl font-extrabold text-black">
                    Sign in to your account
                </h2>
            </div>
            <form className="mt-8 space-y-6" onSubmit={handleLogin}>
                {error && <p className="text-red-500 text-sm text-center">{error}</p>}
                {message && <p className="text-green-500 text-sm text-center">{message}</p>}
                <div className="rounded-md shadow-sm -space-y-px">
                    <div>
                        <input id="email-address" name="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm" placeholder="Email address" />
                    </div>
                    <div>
                        <input id="password" name="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm" placeholder="Password" />
                    </div>
                </div>

                <div className="flex items-center justify-between">
                    <div className="text-sm">
                        <a href="#" onClick={handlePasswordReset} className="font-medium text-indigo-600 hover:text-[#7B34BB]">
                            Forgot your password?
                        </a>
                    </div>
                </div>

                <div>
                    <button type="submit" className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-[#B67BF4] hover:bg-[#7B34BB] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                        Sign in
                    </button>
                </div>
            </form>
             <p className="mt-4 text-center text-sm text-gray-600">
                Don't have an account?{' '}
                                        <a href="#" onClick={() => setModalType('signup')} className="font-medium text-indigo-600 hover:text-[#7B34BB]">
                    Sign up
                </a>
            </p>
        </div>
    );
};

export default LoginPage;

